import React, { useEffect } from "react";

import SearchApp from "./components/SearchApp";
import ReactGA from "react-ga4";  // ✅ GA4 라이브러리 추가
import { useLocation } from "react-router-dom";
import "./App.css"; // CSS 파일 불러오기


// ✅ Google Analytics 초기화 (GA4 Measurement ID 입력)
ReactGA.initialize("G-8JY5R56ED8"); 


function App() {
    const location = useLocation();
    useEffect(() => {
        // ✅ 페이지 이동 감지 후 Google Analytics에 기록
        ReactGA.send({ hitType: "pageview", page: location.pathname });
    }, [location]);

    return <SearchApp />;
}

export default App;
